var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#55ACEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.019 12.488a8.288 8.288 0 01-2.386.653 4.164 4.164 0 001.827-2.297 8.314 8.314 0 01-2.637 1.007 4.154 4.154 0 00-7.078 3.789 11.79 11.79 0 01-8.56-4.34 4.153 4.153 0 001.285 5.545 4.124 4.124 0 01-1.882-.52v.053a4.156 4.156 0 003.332 4.072 4.138 4.138 0 01-1.876.072 4.158 4.158 0 003.88 2.884 8.333 8.333 0 01-6.149 1.72 11.748 11.748 0 006.366 1.866c7.64 0 11.817-6.329 11.817-11.818 0-.18-.004-.359-.012-.537a8.422 8.422 0 002.073-2.15z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.041 9.5l6.564 8.776L9 25.41h1.487l5.782-6.247 4.672 6.247H26l-6.933-9.27L25.215 9.5h-1.487l-5.325 5.753L14.1 9.5H9.041zm2.186 1.095h2.324l10.263 13.721H21.49L11.228 10.595z",
    fill: "#fff"
  })));
}
export default SvgTwitter;